module.exports = __webpack_public_path__ + "img/SKMA_rules1.1a389cdf.png";